import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { ReceiptContextmenuComponent } from '@app/core/components/contextmenus';
import { DetailReceiptComponent, CancelReceiptComponent } from '@app/core/windows'; 
import { ActivatedRoute  } from '@angular/router';


@Component({
  selector: 'receipts-crud',
  templateUrl: './receipts-crud.component.html',
  providers: [ DatasourceService ]
})
export class ReceiptsCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(DetailReceiptComponent, {static: false}) window_detail !: DetailReceiptComponent;

  //Window - Cancel
  @ViewChild(CancelReceiptComponent, {static: false}) window_cancel !: CancelReceiptComponent;

  //Menu
  @ViewChild(ReceiptContextmenuComponent, {static: false}) menu_cre !: ReceiptContextmenuComponent;

  protected menu: string = 'Créditos';

  protected menuIcon: string = 'dollar';
  
  protected label: string = 'Recibos';

  protected name: string = 'Recibos';

  protected table: string = 'receipts';

  private sub: any;

  protected status: string = 'ALL';
  
  constructor(private route: ActivatedRoute, protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'date', dir: 'desc'}
    ];

    // if(this.status != 'ALL') {

    //   s.filter = {
    //     logic: "and",
    //     filters: [
    //       {field: 'status_payment', operator: (this.status != 'PAID') ? 'neq': 'eq', value: 'PAGADO'}
    //     ]
    //   };

    // }

    return s;

  }

  public onCustomExcelExport(e: any, allData: Array<any>): void {

    console.log('onCustomExcelExport');

    const rows = e.workbook.sheets[0].rows;

    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {+
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              case 'Estatus': {
                cell.background = '#' + allData[index-1].status_credit_color;
                cell.color = '#ffffff';
              }; break;
              case 'Costo': {
                cell.format = "$#,##0.00";
              }; break;
            }
          }
        });
      }
    });

  }

  public onCellClick(e: any): void {
      
    console.log(e);
    if (e.type === 'contextmenu') {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();
      // this.menu_proy.label = 'Folio consecutivo: ' + e.dataItem.folio_consecutivo;
      this.menu_cre.contextItem = e.dataItem;
      this.menu_cre.menu.show({ left: originalEvent.pageX, top: originalEvent.pageY });
    }

  }

  // public dblClickEvent(e : any) : void {

  //   // console.log('dblClickEvent', e);
  //   if (e.path[1].nodeName === 'TR') {
  //     let index = e.path[1].rowIndex;
  //     let data : DataResult = this.grid.data as DataResult;
  //     this.permissions.edit(data.data[index]);
  //   }

  // }

  public selectMenu({ menu, contextItem }): void {
    
    console.log("selectMenu", menu, contextItem);

    if (menu.url === 'ver') {

      this.window_detail.id = contextItem.id;
      this.window_detail.type = contextItem.type;
      this.window_detail.edit(contextItem)

    } 
    else if (menu.url === 'cancelar') {

      this.window_cancel.cancel(contextItem);
      // this.alertService.confirmCancel(this.getObjectString(contextItem), () => {

      //   this.onCancel(contextItem)
  
      // });

    } 

  }

  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`
    ].join('\n')

  };

  public onCancel(data: any): void {
    
    console.log('data', data)

    this.service.post('receipt_cancel', data) 
      .subscribe(
        (res) => {
          console.log("DELETE Request is successful: ", this.table, data);
          // console.log("mode = " + this.mode);
          // this.save.emit({mode: this.mode, dataItem: res.data[0]});
          // this.opened = false;
          let msg = this.getObjectString(data)
          this.alertService.showSuccess('Se canceló con éxito el recibo: ' + msg);
          this.refreshHandler();

        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 

  }

  public windowSaveCancelReceiptHandler(event: any): void {

    // console.log(event);
    let msg = this.getObjectString(event.dataItem);
    this.alertService.showSuccess('Se canceló con éxito el recibo: ' + msg);
    this.refreshHandler();

  }

  

  ngOnInit() { 
    
    super.ngOnInit();    

    this.breadcrumbItems = this.getBreadcumItems();

  }

}